import { useTable } from 'react-table';
import './print.css';

function PartyBalanceTable({ data, columns }) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        <table
          style={{
            width: '100%',
            height: '500px',
          }}
          {...getTableProps()}
        >
          <thead style={{ height: '45px', width: '100%' }}>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    style={
                      columns.width
                        ? {
                            width: columns.width,
                            border: '1px solid black',
                            fontSize: '10px',
                          }
                        : {
                            flex: 1,
                            border: '1px solid black',
                          }
                    }
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody
            style={{ width: '100%', overflow: 'hidden', overflowY: 'Scroll' }}
            {...getTableBodyProps()}
          >
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr
                  style={{
                    height: '30px',
                    width: '100%',
                    pageBreakInside: 'avoid',
                    pageBreakAfter: 'auto',
                  }}
                  {...row.getRowProps()}
                >
                  {row.cells.map((cell) => {
                    const cellValue = cell.render('Cell');

                    const isLastColumns =
                      cell.column.id === 'DEBIT' ||
                      cell.column.id === 'CREDIT' ||
                      cell.column.id === 'OP_CREDIT' ||
                      cell.column.id === 'OP_DEBIT';

                    const cellContent =
                      isLastColumns && cellValue.props.value === 0
                        ? ''
                        : cellValue;

                    const rowWidth = cell.column.width;

                    const cellStyle = {
                      border: '1px dotted black',
                      fontSize: '12px',
                      textAlign: isLastColumns ? 'right' : 'left',
                      width: rowWidth,
                    };

                    return (
                      <td
                        className="pl-2 pr-3"
                        style={cellStyle}
                        {...cell.getCellProps()}
                      >
                        {cellContent}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PartyBalanceTable;
